import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import ReactHtmlParser from "html-react-parser";

import { useTaskDetailContext } from "contexts/TaskDetailContext";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

import { localizeDateMed } from "utils/dateFormats";
import { AccountCircleOutlined, AttachFile, Category, ColorizeRounded, DateRange, DateRangeOutlined, InfoOutlined, PriorityHigh } from "@mui/icons-material";
import FileIcon from "components/Shared/FileIcon";

const TaskBasicDetail = () => {
  const { taskDetail, loadingTask } = useTaskDetailContext();

  return !loadingTask ? (
    <Box padding={3}>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Typography variant="h6">{taskDetail?.title}</Typography>
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <Category color="primary" />}
            title="Category"
            subtitle={taskDetail?.category?.name}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <PriorityHigh color="primary" />}
            title="Priority"
            subtitle={taskDetail?.priority}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <DateRange color="primary" />}
            title="Due Date"
            subtitle={localizeDateMed(taskDetail?.dueDate)}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <ColorizeRounded color="primary" />}
            title="Responsible"
            subtitle={taskDetail?.responsible?.name}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <DateRangeOutlined color="primary" />}
            title="Created Date"
            subtitle={localizeDateMed(taskDetail?.createdAt)}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccountCircleOutlined color="primary" />}
            title="Created By"
            subtitle={taskDetail?.createdBy?.name ?? "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={taskDetail?.isActive} />
          </InformationTile>
        </Grid>
        
        <Grid item md={3}>
          <InformationTile
            icon={() => <AttachFile color="primary" />}
            title="Attachments"
          >
            {taskDetail?.attachments && (
              <div className="flex gap-4">
                {taskDetail?.attachments?.map((attachment) => (
                  <a
                    key={attachment?._id}
                    href={attachment?.url}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "var(--primary)" }}
                  >
                    <FileIcon
                      fileName={attachment?.name}
                      fileUrl={attachment?.url}
                    />
                  </a>
                ))}
              </div>
            )}
          </InformationTile>
        </Grid>
      </Grid>

      {!!taskDetail?.description && (
        <Box marginTop={3}>
          <div>{ReactHtmlParser(taskDetail?.description) ?? "N/A"}</div>
        </Box>
      )}
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default TaskBasicDetail;